import Skeleton from '@mui/material/Skeleton';
import { Text } from 'components/Text';
import { getTrans } from 'modules/i18n';

export const ShiftsSkeleton = () => (
  <>
    <Text variant="h5" align="center" sx={{ mb: 2 }}>
      {getTrans('weekDetailsPage.shifts.title')}
    </Text>
    <Skeleton data-testid="shifts-skeleton" height={80} />
  </>
);
